import styled from 'styled-components'

const Section = styled.section`
  padding: ${({ padding }) => padding || '40px 0'};
`

export default Section
